exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".field {\n  padding: 6px 0px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: block;\n  font-size: 0.9rem; }\n  .field-name {\n    font-size: 1em;\n    color: rgba(10, 10, 10, 0.6);\n    font-weight: 500;\n    margin: 0px;\n    padding: 0px; }\n  .field-value {\n    margin: 5px 0px;\n    padding: 0px;\n    font-weight: 400;\n    font-size: 1em;\n    color: #0a0a0a; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/sass-loader/lib/loader.js!./src/shared/components/field.scss
// module id = 1141
// module chunks = 0